import React from "react";
import { observer } from "mobx-react-lite";

import { useFieldsScreenVM } from "@screens/FieldsScreen/FieldsScreenVM";
import TrackFilterControls from "@screens/TracksScreen/TrackFilterControls";

/** The shared track filter controls, bound to the Fields screen VM. */
const FieldTracksFilters: React.FC = () => {
  const vm = useFieldsScreenVM();
  return (
    <TrackFilterControls
      // Bands are sensor-value colors, so they apply to the sensor metric in
      // either color mode: cutting off the red end still means "hide low yield"
      // when swaths are colored by machine.
      colorApplies={vm.trackMetric === "sensor"}
      colorOn={vm.trackColorFilterOn}
      sensorMin={vm.trackSensorMin}
      sensorMax={vm.trackSensorMax}
      onColorToggle={vm.setTrackColorFilterOn}
      onSensorRange={vm.setTrackSensorRange}
      speedOn={vm.trackSpeedFilterOn}
      speedMinKmh={vm.trackSpeedMinKmh}
      speedMaxKmh={vm.trackSpeedMaxKmh}
      onSpeedToggle={vm.setTrackSpeedFilterOn}
      onSpeedRange={vm.setTrackSpeedRange}
      removeTurns={vm.trackRemoveTurns}
      onRemoveTurnsToggle={vm.setTrackRemoveTurns}
    />
  );
};

export default observer(FieldTracksFilters);
